$(function(){
  $(document).on('click', '.js-sidr-open', () => {

    if(! $("html").is(".is-sidr") ){
      $("html").addClass("is-sidr");
      $("html").removeClass("hide-sidr");
    } else{
      $("html").removeClass("is-sidr");
      $("html").addClass("hide-sidr");
    }
  });

  $(window).on('resize orientationchange', () => {
    if( $("html").is(".width-pc") ){
      $("html").removeClass("is-sidr");
    }
  });

  $(document).on('click', '.js-sidr-close', () => {
    $("html").removeClass("is-sidr");
  })
});



// WEBPACK FOOTER //
// ./_src/js/action/sp-menu.js